export default "__VITE_ASSET__B5K7aarv__"